import { defineAsyncComponent } from 'vue'
export default {
  "job-preview": defineAsyncComponent(() => import("/opt/render/project/src/layouts/job-preview.vue").then(m => m.default || m))
}